import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const Item = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:100%;
  border: 1px solid var(--primary);
  color: var(--secondary);
  background-color: var(--darkBlue);
  border-radius: 2rem;
  padding: 2rem 3rem;
  margin: 1rem 0;
  gap: 1rem;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  /* flex-wrap: wrap; */
  width:100%;
  /* border: 1px solid var(--primary);
  border-radius: 2rem; */
  padding: 2rem 3rem;
  margin: 1rem 0;
  gap: 1rem;

  border: 0.1rem solid;
  border-radius: 2rem;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--darkBlue);
  background-color: var(--softGray);

   @media (max-width: 920px) {
    flex-direction: column;
  }
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width:80%;
  padding: 0;
`;

export const Button = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  width:19%;
  height: 100%;
  padding: 0;
  gap: 1rem;
`;

export const Link = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width:100%;
  gap: 1rem;
`;